<div class="dialog-title-row" fxLayout="row" fxLayoutAlign="space-between center">
  <h2 mat-dialog-title>{{ data.title }}</h2>
  <button mat-icon-button class="close-button" (click)="close()" aria-label="Fechar">
    <mat-icon class="close-icon" color="warn">close</mat-icon>
  </button>
</div>

<div mat-dialog-content class="dialog-content">
  <mat-card class="p-0 popup-wrapper">
    <div class="popup-actions">
      <button mat-raised-button color="primary" (click)="$event.preventDefault(); popUpOcorrencia({}, true)">
        <mat-icon>add_alert</mat-icon>
        Nova Ocorrência
      </button>
    </div>

    <ng-container *ngIf="layoutConf?.isMobile; else desktopOcorrenciaTable">
      <div class="mobile-cards-wrap" *ngIf="ocorrencias?.length; else emptyOcorrenciaList">
        <mat-card class="mobile-card" *ngFor="let row of ocorrencias; let i = index">
          <div class="mobile-card-header">
            <div class="mobile-card-title">#{{ i + 1 }} - {{ (row?.dataOcorrencia | date:'dd/MM/yyyy') || 'Sem data' }}</div>
            <div class="mobile-card-actions">
              <button mat-icon-button color="primary" matTooltip="Editar" (click)="$event.preventDefault(); popUpOcorrencia(row)">
                <mat-icon>edit</mat-icon>
              </button>
              <button mat-icon-button color="warn" matTooltip="Excluir" (click)="$event.preventDefault(); deleteOcorrencia(row)">
                <mat-icon>delete</mat-icon>
              </button>
            </div>
          </div>

          <div class="mobile-card-line">
            <span>Ocorrência</span>
            <strong>{{ row?.ocorrencia || '-' }}</strong>
          </div>
          <div class="mobile-card-grid">
            <div><span>Avisar</span><strong>{{ row?.avisar?.descricao || '-' }}</strong></div>
            <div><span>Status</span><strong>{{ row?.status || '-' }}</strong></div>
            <div><span>Válido de</span><strong>{{ (row?.dataAvisarInicial | date:'dd/MM/yyyy') || '-' }}</strong></div>
            <div><span>Válido até</span><strong>{{ (row?.dataAvisarFinal | date:'dd/MM/yyyy') || '-' }}</strong></div>
          </div>
        </mat-card>
      </div>

      <mat-paginator
        class="mobile-paginator"
        #paginatorOcorrencia
        [length]="lengthOcorrencia"
        [showFirstLastButtons]="true"
        [pageSize]="pageSizeOcorrencia"
        [pageSizeOptions]="pageSizeOptionsOcorrencia"
        (page)="pageEventOcorrencia = setPageSizeOptionsOcorrencia($event)">
      </mat-paginator>
    </ng-container>

    <ng-template #desktopOcorrenciaTable>
      <ngx-datatable
        class="material ml-0 mr-0"
        [rows]="ocorrencias"
        [headerHeight]="50"
        [footerHeight]="50"
        [scrollbarH]="true"
        [messages]="{emptyMessage:'Nenhuma Ocorrência encontrada'}"
        [limit]="pageSizeOcorrencia"
        [rowHeight]="50">
        <ngx-datatable-column name="#" [width]="25">
          <ng-template let-rowIndex="rowIndex" ngx-datatable-cell-template>
            <strong>{{ rowIndex + 1 }}</strong>
          </ng-template>
        </ngx-datatable-column>
        <ngx-datatable-column name="Opções" [flexGrow]="1" [width]="100">
          <ng-template let-row="row" ngx-datatable-cell-template>
            <button mat-icon-button mat-sm-button color="primary" class="mr-1" (click)="$event.preventDefault(); popUpOcorrencia(row)">
              <mat-icon>edit</mat-icon>
            </button>
            <button mat-icon-button mat-sm-button color="warn" (click)="$event.preventDefault(); deleteOcorrencia(row)">
              <mat-icon>delete</mat-icon>
            </button>
          </ng-template>
        </ngx-datatable-column>

        <ngx-datatable-column name="Data" [flexGrow]="1" [width]="100">
          <ng-template let-row="row" ngx-datatable-cell-template>
            {{ row?.dataOcorrencia | date:'dd/MM/yyyy' }}
          </ng-template>
        </ngx-datatable-column>

        <ngx-datatable-column name="Ocorrência" [flexGrow]="2" [width]="250">
          <ng-template let-row="row" ngx-datatable-cell-template>
            <span [matTooltip]="row?.ocorrencia">{{ row?.ocorrencia }}</span>
          </ng-template>
        </ngx-datatable-column>

        <ngx-datatable-column name="Avisar" [flexGrow]="1" [width]="180">
          <ng-template let-row="row" ngx-datatable-cell-template>
            {{ row?.avisar?.descricao }}
          </ng-template>
        </ngx-datatable-column>

        <ngx-datatable-column name="Validade" [flexGrow]="1" [width]="180">
          <ng-template let-row="row" ngx-datatable-cell-template>
            <span *ngIf="row?.dataAvisarInicial || row?.dataAvisarFinal">
              {{ (row?.dataAvisarInicial | date:'dd/MM/yyyy') || '...' }} — {{ (row?.dataAvisarFinal | date:'dd/MM/yyyy') || '...' }}
            </span>
          </ng-template>
        </ngx-datatable-column>

        <ngx-datatable-column name="Status" [flexGrow]="1" [width]="120">
          <ng-template let-row="row" ngx-datatable-cell-template>
            {{ row?.status }}
          </ng-template>
        </ngx-datatable-column>

        <ngx-datatable-footer>
          <ng-template ngx-datatable-footer-template>
            <mat-paginator
              #paginatorOcorrencia
              [length]="lengthOcorrencia"
              fxLayoutAlign="space-around center"
              [showFirstLastButtons]="true"
              [pageSize]="pageSizeOcorrencia"
              [pageSizeOptions]="pageSizeOptionsOcorrencia"
              (page)="pageEventOcorrencia = setPageSizeOptionsOcorrencia($event)">
            </mat-paginator>
          </ng-template>
        </ngx-datatable-footer>
      </ngx-datatable>
    </ng-template>

    <ng-template #emptyOcorrenciaList>
      <div class="empty-state">Nenhuma ocorrência encontrada.</div>
    </ng-template>
  </mat-card>
</div>

<mat-dialog-actions align="end" class="dialog-actions">
  <button mat-button color="warn" type="button" (click)="close()">
    <mat-icon>close</mat-icon>
    {{"CLOSE" | translate }}
  </button>
</mat-dialog-actions>
